// extracted by mini-css-extract-plugin
export default {"input":"Fka-z","button":"Gka-z","selected":"Hka-z","sephoraImage":"Ika-z","unavailable":"Jka-z","image":"Kka-z"};